<div *ngIf="!style_simple" class="f1 dflex w100 fcolumn">
  <div>
    <table mat-table class="w100" [dataSource]="dataSource">
      <ng-container matColumnDef="preco">
        <th mat-header-cell *matHeaderCellDef>Preço promocional</th>
        <td mat-cell *matCellDef="let element">
          R$ {{ element.preco | number: ".2" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="validade_inicial">
        <th mat-header-cell *matHeaderCellDef>Inicio</th>
        <td mat-cell *matCellDef="let element">
          {{ element.validade_inicial.replace(" ", "T") | date: "d/MM/y H:mm" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="validade_final">
        <th mat-header-cell *matHeaderCellDef>Fim</th>
        <td mat-cell *matCellDef="let element">
          {{ element.validade_final.replace(" ", "T") | date: "d/MM/y H:mm" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="comprando">
        <th mat-header-cell *matHeaderCellDef>condição</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.multiplo && element.comprando"
            ><span *ngIf="element.multiplo == 'N'">A partir de&nbsp;</span
            ><span *ngIf="element.multiplo == 'S'">A cada&nbsp;</span
            >{{ element.comprando }} unidades</span
          >
          <span *ngIf="!element.multiplo || !element.comprando">nenhuma</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th class="tcenter" mat-header-cell *matHeaderCellDef>Status</th>
        <td class="tcenter" mat-cell *matCellDef="let element">
          <span
            class="badge rounded-pill"
            [ngClass]="{
              'bg-green': element.ativo,
              'bg-gray': !element.ativo,
              tdgray: !element.ativo
            }"
            >{{ element.ativo ? "Promoção ativa" : "inativa" }}</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="acoes">
        <th
          class="tcenter"
          mat-header-cell
          style="width: 200px"
          *matHeaderCellDef
        ></th>
        <td class="tcenter" mat-cell *matCellDef="let element">
          <button
            type="button"
            (click)="onEditOffer(element)"
            class="btn btn-warning-outline mr10"
          >
            Editar
          </button>
          <button
            type="button"
            (click)="onDeleteOffer(element)"
            class="btn btn-danger-outline mr10"
          >
            Apagar
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        (dblclick)="onEditOffer(row)"
        mat-row
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>

    <mat-paginator
      (page)="handlePageEvent($event)"
      [length]="length"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[5, 10, 20]"
      [hidePageSize]="true"
      showFirstLastButtons
    >
    </mat-paginator>
  </div>
  <div class="dflex frow mt20 mb20 jend">
    <button
      type="button"
      (click)="onAddNewOffer()"
      class="btn btn-primary-outline mr10"
    >
      Adicionar nova promoção
    </button>
  </div>
</div>

<div *ngIf="style_simple" class="f1 dflex w100 fcolumn">
  <div>
    <table mat-table class="w100 table-simple" [dataSource]="dataSource">
      <ng-container matColumnDef="preco">
        <td mat-cell *matCellDef="let element">
          <strong class="price">R$ {{ element.preco | number: ".2" }}</strong>
        </td>
      </ng-container>

      <ng-container matColumnDef="comprando">
        <td class="f2" mat-cell *matCellDef="let element">
          <span *ngIf="element.multiplo && element.comprando"
            ><span *ngIf="element.multiplo == 'N'">a partir de&nbsp;</span
            ><span *ngIf="element.multiplo == 'S'">a cada&nbsp;</span
            ><strong>{{ element.comprando }} unidades</strong></span
          >
          <span *ngIf="!element.multiplo || !element.comprando"
            >nenhuma condição</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="validade_inicial">
        <td class="dnone-sxm" mat-cell *matCellDef="let element">
          {{ element.validade_inicial.replace(" ", "T") | date: "d/MM/y" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="acoes">
        <td class="jevenly" mat-cell *matCellDef="let element">
          <button type="button" (click)="onEditOffer(element)">
            <fa-icon [icon]="faEdit"></fa-icon>
          </button>
          <button type="button" (click)="onDeleteOffer(element)">
            <fa-icon [icon]="faTimesCircle"></fa-icon>
          </button>
        </td>
      </ng-container>

      <tr
        (dblclick)="onEditOffer(row)"
        mat-row
        *matRowDef="let row; columns: displayedSimpleColumns"
      ></tr>
    </table>
  </div>
  <div class="dflex frow mt20 mb20 jstart">
    <a class="link-simple" (click)="onAddNewOffer()">
      <fa-icon [icon]="faPlus"></fa-icon> Adicionar mais uma oferta?
    </a>
  </div>
</div>

<div
  *ngIf="showModal"
  class="modal modal-center open pnl-modal-offer"
  [class.modal-simple]="style_simple"
>
  <div>
    <div>
      <form [formGroup]="offerFrm" (ngSubmit)="onSubmit()" novalidate>
        <div class="promocao">
          <header *ngIf="style_simple">
            <nav>
              <a (click)="onCancel()"
                ><fa-icon [icon]="faChevronLeft" class="mr10"></fa-icon> Preço
                R$ {{ normal_price | number: ".2" }}</a
              >
            </nav>
            <img src="assets/img/add_offers.jpg" />
            <h4>Adicionar oferta</h4>
          </header>
          <div>
            <div class="preco">
              <div>
                <strong>Preço promocional</strong>
                <div class="ipt-form">
                  <input
                    type="text"
                    (keyup)="updatePerc()"
                    formControlName="oferta_preco"
                    currencyMask
                    class="form-control"
                  />
                  <span
                    *ngIf="normal_price"
                    [class.promotion]="oferta_preco.value > 0"
                    >{{ oferta_off }}%</span
                  >
                </div>
              </div>

              <div class="comprando">
                <mat-radio-group
                  formControlName="oferta_multiplo"
                  (change)="onChangeDetail()"
                  class="mb10"
                >
                  <mat-radio-button value="N" class="mr10"
                    >A partir de
                  </mat-radio-button>
                  <mat-radio-button value="S" class="mr10"
                    >A cada</mat-radio-button
                  >
                  <mat-radio-button value="">Sem exigência</mat-radio-button>
                </mat-radio-group>
                <div class="ipt-form">
                  <input
                    type="text"
                    formControlName="oferta_comprando"
                    (keyup)="onChangeDetail()"
                    currencyMask
                    [attr.disabled]="oferta_multiplo.value == '' ? true : null"
                    [options]="{ precision: 0, allowNegative: false }"
                    class="form-control"
                  />
                  <span *ngIf="oferta_multiplo.value != ''">Unidades</span>
                </div>
              </div>
            </div>

            <div class="permanencia">
              <strong> Permanência </strong>
              <div>
                <div class="frm">
                  <div>
                    <label>Data de início</label>
                    <div class="frm-datepicker">
                      <input
                        type="text"
                        (dateInput)="onChangeDetail()"
                        formControlName="oferta_validade_inicial"
                        class="form-control"
                        [matDatepicker]="pickerInicialDate"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="pickerInicialDate"
                      ></mat-datepicker-toggle>
                      <mat-datepicker
                        #pickerInicialDate
                        [startAt]="startDate"
                      ></mat-datepicker>
                    </div>
                  </div>
                  <div>
                    <label>Hora inicial</label>
                    <div class="hora_inicial">
                      <input
                        type="text"
                        class="form-control"
                        matInput
                        formControlName="oferta_validade_inicial_hora"
                        (keyup)="onChangeDetail()"
                        mask="Hh:m0"
                        [dropSpecialCharacters]="false"
                        placeholder="00:00"
                      />
                      <i class="ic ic-clock-gray"></i>
                    </div>
                  </div>
                </div>
                <div class="frm">
                  <div>
                    <label>Data de expiração</label>
                    <div class="frm-datepicker">
                      <input
                        type="text"
                        (dateInput)="onChangeDetail()"
                        [min]="oferta_validade_inicial.value"
                        formControlName="oferta_validade_final"
                        class="form-control"
                        [matDatepicker]="pickerFinalDate"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="pickerFinalDate"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #pickerFinalDate></mat-datepicker>
                    </div>
                  </div>
                  <div>
                    <label>Hora de expiração</label>
                    <div class="hora_inicial">
                      <input
                        type="text"
                        class="form-control"
                        matInput
                        formControlName="oferta_validade_final_hora"
                        (keyup)="onChangeDetail()"
                        mask="Hh:m0"
                        [dropSpecialCharacters]="false"
                        placeholder="00:00"
                      />
                      <i class="ic ic-clock-gray"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="obs">
              <strong> Observação </strong>
              <div class="frm fdc">
                <label>Se necessário, detalhe as regras da promoção</label>
                <textarea
                  class="text-control"
                  (keyup)="onChangeDetail()"
                  formControlName="oferta_obs"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="dflex frow mt20 mb20 jend mr10">
          <button
            type="button"
            (click)="onCancel()"
            class="btn btn-cancel mr10"
          >
            Cancelar
          </button>
          <button
            type="button"
            (click)="onSubmit()"
            class="btn btn-primary mr10"
          >
            Salvar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
